import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchDeveloperBySlug } from "../api/GlobalApi";

function DeveloperPage() {
  const { slug } = useParams();
  const [developer, setDeveloper] = useState(null);
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug) return;

    fetchDeveloperBySlug(slug)
      .then((data) => {
        console.log("Developer API response:", data);
        setDeveloper(data.developer || data);
        setApps(data.apps || data.developer?.apps || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setLoading(false);
      });
  }, [slug]);

  // Normalize rating between 0–5
  const parseRating = (r) => {
    if (r === null || r === undefined || r === "") return 0;
    const n = typeof r === "number" ? r : Number(String(r).replace(",", "."));
    if (!Number.isFinite(n)) return 0;
    return Math.max(0, Math.min(5, n));
  };

  // Render star icons dynamically
  const renderStars = (rawRating) => {
    const rating = parseRating(rawRating);
    const totalStars = 5;
    const fullStars = Math.floor(rating);
    const halfStar = rating - fullStars >= 0.5 && fullStars < totalStars;
    const stars = [];

    for (let i = 0; i < totalStars; i++) {
      if (i < fullStars) stars.push(<span key={i}>★</span>);
      else if (i === fullStars && halfStar) stars.push(<span key={i}>⯨</span>);
      else stars.push(<span key={i}>☆</span>);
    }

    return <span className="stars">{stars}</span>;
  };

  if (loading)
    return (
      <div style={styles.loaderContainer}>
        <div style={styles.spinner}></div>
      </div>
    );

  if (!developer) {
    return (
      <div style={styles.errorContainer}>
        <h2>Developer Not Found</h2>
        <p>The requested developer could not be found.</p>
      </div>
    );
  }

  return (
    <main className="main-content">
      <section className="section">
        <section
          className="app-header"
          style={{
            backgroundImage: `url(${developer.developer_banner_url || "/default-banner.jpg"})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            color: "white",
            textShadow: "0 0 10px rgba(0,0,0,0.5)",
          }}
        >
          <div className="app-icon-large">
            <img
              src={developer.developer_logo_url}
              style={{ width: "inherit", height: "inherit" }}
              alt={developer.developer_name || developer.name || "Developer"}
            />
          </div>

          <div className="app-info">
            <h1 className="app-title">
              {developer.developer_name || developer.name}
            </h1>

            <div className="download-section">
              <button className="wishlist-btn" title="Add to Wishlist">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5 2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z" />
                </svg>
              </button>

              <button className="share-btn" title="Share">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18,16.08C17.24,16.08 16.56,16.38 16.04,16.85L8.91,12.7C8.96,12.47 9,12.24 9,12C9,11.76 8.96,11.53 8.91,11.3L15.96,7.19C16.5,7.69 17.21,8 18,8A3,3 0 0,0 21,5A3,3 0 0,0 18,2A3,3 0 0,0 15,5C15,5.24 15.04,5.47 15.09,5.7L8.04,9.81C7.5,9.31 6.79,9 6,9A3,3 0 0,0 3,12A3,3 0 0,0 6,15C6.79,15 7.5,14.69 8.04,14.19L15.16,18.34C15.11,18.55 15.08,18.77 15.08,19C15.08,20.61 16.39,21.91 18,21.91C19.61,21.91 20.92,20.61 20.92,19A2.92,2.92 0 0,0 18,16.08Z" />
                </svg>
              </button>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <h2>Apps by {developer.developer_name || developer.name}</h2>
          </div>

          {apps.length === 0 ? (
            <div style={styles.noPosts}>
              <p>There are no apps for this developer.</p>
            </div>
          ) : (
            <div className="games-grid">
              {apps.map((app) => {
                const ratingNum = parseRating(app.rating);
                return (
                  <Link
                    to={`/app/details/${app.slug}`}
                    className="game-card"
                    key={app.id}
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      className="game-image"
                      style={{
                        background: "linear-gradient(45deg, #fa709a, #fee140)",
                        backgroundImage: `url(${app.feature_graphic_url || app.icon_url})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <div
                        className="game-icon"
                        style={{
                          backgroundImage: `url(${app.icon_url})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      />
                    </div>

                    <div className="game-info">
                      <div className="game-title">{app.name}</div>
                      <div className="game-developer">{app.developer}</div>
                      <div className="game-rating">
                        {renderStars(ratingNum)}
                        <span className="rating-text">
                          {ratingNum.toFixed(1)}
                        </span>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          )}
        </section>
      </section>
    </main>
  );
}

const styles = {
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "6px solid #ddd",
    borderTop: "6px solid #3498db",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  errorContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    padding: "20px",
    textAlign: "center",
  },
  noPosts: {
    textAlign: "center",
    padding: "40px 20px",
    fontSize: "18px",
    color: "#666",
  },
};

// Inject global CSS once (safe for dev/hmr)
const GLOBAL_STYLE_ID = "devpage-global-styles";
if (typeof document !== "undefined" && !document.getElementById(GLOBAL_STYLE_ID)) {
  const css = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    .stars span {
      color: #FFD700;
      font-size: 1rem;
      margin-right: 1px;
      line-height: 1;
    }
    .game-rating { display: flex; align-items: center; gap: 8px; }
    .rating-text { font-size: 0.9rem; color: #333; }
  `;
  const styleEl = document.createElement("style");
  styleEl.id = GLOBAL_STYLE_ID;
  styleEl.innerHTML = css;
  document.head.appendChild(styleEl);
}

export default DeveloperPage;
